// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"31d6cfe0","123":"31d6cfe0","449":"17f61689","718":"7500942b","801":"31d6cfe0","848":"27a37d86"}[chunkId] + ".chunk.css";
};